import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

// const get = () => {
//   return responseFormatter(
//     http.get(`/whitelistedClients`, {
//       setAuthHeader: true,
//     })
//   );
// };
const get = (query = "", id = "") => {
  return responseFormatter(
    http.get(`/whitelisted-clients${query == null ? id : query}`, {
      setAuthHeader: true,
    })
  );
};

const exportWhiteList = (queryString = "") => {
  return responseFormatter(
    http.get(`/whitelisted-clients/export${queryString}`, {
      setAuthHeader: true,
    })
  );
};

// function get() {

//   return responseFormatter(http.get('/whitelisted-clients', { setAuthHeader: true }));

// }
const Service = {
  get,
  exportWhiteList,
};

export default Service;
